import getJsonLdScriptId from "@insite/client-framework/Common/Utilities/getJsonLdScriptId";
import setPageMetadata, { Metadata } from "@insite/client-framework/Common/Utilities/setPageMetadata";
import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { Website } from "@insite/client-framework/Services/WebsiteService";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, LookUpData } from "@insite/client-framework/Store/CommonHandlers/SetMetadata";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getAlternateLanguageUrls, getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { WebsiteSettingsModel } from "@insite/client-framework/Types/ApiModels";

export const XngLookUpData: typeof LookUpData = props => {
    const state = props.getState();
    const page = getCurrentPage(state);

    const pathname = state.data.pages.location.pathname;
    const alternateLanguageUrls = getAlternateLanguageUrls(state, page.id);
    const websiteName = state.context.website.name;

    // XNG-Changes: STNRS-381: removed page title and replaced it with websiteName + replaced websiteName with a phoneNumber siteMessage
    props.metadata = {
        metaKeywords: page.fields.metaKeywords,
        metaDescription: page.fields.metaDescription,
        openGraphUrl: page.fields.openGraphUrl,
        openGraphTitle: page.fields.openGraphTitle,
        openGraphImage: page.fields.openGraphImage,
        structuredPageData: page.fields.structuredPageData,
        title: websiteName,
        currentPath: pathname,
        canonicalPath: pathname,
        alternateLanguageUrls,
        websiteName: siteMessage("STR_Website_PhoneNumber") as string,
        jsonLdScriptId: getJsonLdScriptId(page.type),
        pageType: page.type,
    };

    props.websiteSettings = getSettingsCollection(state).websiteSettings;

    props.website = state.context.website;
};

replaceInChain(chain, LookUpData, XngLookUpData);
